import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/3d/")({
  beforeLoad: () => {
    throw redirect({ to: "/demo/3d/hero" });
  },
});
